import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=873950d6"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports